import http from './api'

const route = 'app/comercial7/'

export default {
  showDadosFaturamentoComercial: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosFaturamentoComercial', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDevolucao: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosDevolucao', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosMetaVolume: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosMetaVolume', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosVolume: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosVolume', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosFaturamentoVolumeMeta: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosFaturamentoVolumeMeta', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosValorAtingimentoMetas: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosValorAtingimentoMetas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosValorAtingimentoMetasDiario: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosValorAtingimentoMetasDiario', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosTendenciaFaturamento: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosTendenciaFaturamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDiasFaturamento: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosDiasFaturamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosPedidosAbertos: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, area, rede, categoria, promotor, classificacao, linhaProducao) => {
    return http.post(route + 'showDadosPedidosAbertos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      area: area,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhasProducao: linhaProducao,
      tokenContrato: tokenContrato,
    })
  },
}
